import { Component, OnInit, Input } from '@angular/core';
import { Observable } from 'rxjs';
import { Contact } from '../../contact.model';
import { ContactService } from '../../contact.service';
import { ServiceResult } from 'src/app/service-provider/available-services-layout/service-result.model';
import { AngularFireStorage } from '@angular/fire/storage';

@Component({
  selector: 'app-service-contact-listing',
  templateUrl: './service-contact-listing.component.html',
  styleUrls: ['./service-contact-listing.component.scss']
})
export class ServiceContactListingComponent implements OnInit {
  @Input() service: ServiceResult;
  contacts$: Observable<Contact[]>;
  serviceProfileURL$: Observable<string>;
  constructor(
    private contactService: ContactService,
    private firestore: AngularFireStorage
  ) {}

  ngOnInit(): void {
    this.contacts$ = this.contactService.getContactForServiceProvider(
      this.service.documentKey
    );

    if (!!this.service.service.imageId) {
      this.serviceProfileURL$ = this.firestore
        .ref(`service-provider-profiles/${this.service.service.imageId}`)
        .getDownloadURL();
    } else {
      this.serviceProfileURL$ = this.firestore
        .ref(`unknown-profile.jpg`)
        .getDownloadURL();
    }
  }
}
